import React from 'react'
import * as S from './styles'
import { ReactComponent as CheckIcon } from '../../../../../assets/icons/green-check.svg'
import { ReactComponent as WarningIcon } from '../../../../../assets/icons/warning-icon.svg'
import { ReactComponent as DangerIcon } from '../../../../../assets/icons/danger-icon.svg'
import { ReactComponent as InfoIcon } from '../../../../../assets/icons/info-icon.svg'
import { ReactComponent as CloseIcon } from '../../../../../assets/icons/x-icon.svg'
import { ReactComponent as Percentage } from '../../../../../assets/icons/badge-percentage.svg'
import { ReactComponent as LockIcon } from '../../../../../assets/icons/lock-alt.svg'

const icons = {
  info: <InfoIcon />,
  success: <CheckIcon />,
  warning: <WarningIcon />,
  danger: <DangerIcon />,
  campaign: <Percentage />,
  lock: <LockIcon />
}

const Alert = ({ type = 'info', show, onClose, children, customIcon }) => {
  return (
    <>
      {show && (
        <S.AlertContainer type={type}>
          <S.Icon>
            {customIcon || icons[type]}
          </S.Icon>
          <S.Message>{children}</S.Message>
          {onClose &&
            <S.CloseButton onClick={() => onClose()}>
              <CloseIcon />
            </S.CloseButton>}
        </S.AlertContainer>
      )}
    </>
  )
}

export default Alert
